// ─── CONFIRMACIÓN DE BORRADO (admin) ──────────────────────────
// Reemplaza el confirm() nativo por un modal de marca. Intercepta cualquier
// <form data-confirm="mensaje"> (productos, promos, categorías) y solo envía
// el borrado si el usuario confirma. Reusa la lógica del alertas.js original:
// trampa de foco, Escape para cancelar y devolución del foco al cerrar.
// (Sin estilos inline → compatible con la CSP de producción.)
(() => {
  "use strict";

  const modal = document.getElementById("confirmModal");
  if (!modal) return; // no estamos en una página con el modal (público)

  const texto = modal.querySelector("[data-confirm-text]");
  const btnOk = modal.querySelector("[data-confirm-ok]");
  const btnCancel = modal.querySelector("button[data-confirm-cancel]");
  const cierres = modal.querySelectorAll("[data-confirm-cancel]");

  let formPendiente = null;
  let focoPrevio = null;

  const abrir = (form) => {
    formPendiente = form;
    focoPrevio = document.activeElement;
    if (texto) texto.textContent = form.dataset.confirm || "Esta acción no se puede deshacer.";
    modal.hidden = false;
    // Enfoca "Cancelar" por defecto (acción segura ante un Enter accidental).
    (btnCancel || btnOk).focus();
  };

  const cerrar = () => {
    modal.hidden = true;
    formPendiente = null;
    if (focoPrevio && typeof focoPrevio.focus === "function") focoPrevio.focus();
  };

  // Intercepta el envío de los formularios de borrado.
  document.querySelectorAll("form[data-confirm]").forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      abrir(form);
    });
  });

  // Confirmar → envía el form. form.submit() NO vuelve a disparar el evento
  // "submit", así que no re-abre el modal.
  btnOk.addEventListener("click", () => {
    if (!formPendiente) return;
    const form = formPendiente;
    cerrar();
    form.submit();
  });

  // Cancelar (botón u overlay).
  cierres.forEach((el) => el.addEventListener("click", cerrar));

  // Escape cancela; Tab queda atrapado entre los dos botones.
  modal.addEventListener("keydown", (event) => {
    if (modal.hidden) return;
    if (event.key === "Escape") {
      cerrar();
      return;
    }
    if (event.key === "Tab") {
      const botones = modal.querySelectorAll("button"); // [cancelar, confirmar] en orden DOM
      if (botones.length < 2) return;
      const primero = botones[0];
      const ultimo = botones[botones.length - 1];
      if (event.shiftKey && document.activeElement === primero) {
        event.preventDefault();
        ultimo.focus();
      } else if (!event.shiftKey && document.activeElement === ultimo) {
        event.preventDefault();
        primero.focus();
      }
    }
  });
})();
